import { NgModule } from '@angular/core';
import {
  LucideSearch,
  LucidePlus,
  LucideTrash2,
  LucideEdit2,
  LucidePenLine,
  LucideDownload,
  LucideUpload,
  LucideChevronDown,
  LucideChevronRight,
  LucideChevronLeft,
  LucideCheck,
  LucideX,
  LucideUsers,
  LucideFileText,
  LucideLayoutDashboard,
  LucideSettings,
  LucideLogOut,
  LucideBell,
  LucideMenu,
  LucideMoreVertical,
  LucideMoreHorizontal,
  LucideFilter,
  LucideEye,
  LucideEyeOff,
  LucideAlertCircle,
  LucideBuilding2,
  LucideShield,
  LucideMapPin,
  LucideHash,
  LucideArrowLeft,
  LucideTrendingUp,
  LucideWallet,
  LucideBookOpen,
  LucideChartColumn,
  LucideCircleCheck,
  LucideCircleX,
  LucideClipboardList,
  LucideLink2,
  LucideLoaderCircle,
  LucideSend,
  LucideSheet,
  LucideSkipForward,
  LucideScale,
} from '@lucide/angular';

const ICONS = [
  LucideSearch,
  LucidePlus,
  LucideTrash2,
  LucideEdit2,
  LucidePenLine,
  LucideDownload,
  LucideUpload,
  LucideChevronDown,
  LucideChevronRight,
  LucideChevronLeft,
  LucideCheck,
  LucideX,
  LucideUsers,
  LucideFileText,
  LucideLayoutDashboard,
  LucideSettings,
  LucideLogOut,
  LucideBell,
  LucideMenu,
  LucideMoreVertical,
  LucideMoreHorizontal,
  LucideFilter,
  LucideEye,
  LucideEyeOff,
  LucideAlertCircle,
  LucideBuilding2,
  LucideShield,
  LucideMapPin,
  LucideHash,
  LucideArrowLeft,
  LucideTrendingUp,
  LucideWallet,
  LucideBookOpen,
  LucideChartColumn,
  LucideCircleCheck,
  LucideCircleX,
  LucideClipboardList,
  LucideLink2,
  LucideLoaderCircle,
  LucideSend,
  LucideSheet,
  LucideSkipForward,
  LucideScale,
];

@NgModule({
  imports: ICONS,
  exports: ICONS,
})
export class SharedIconsModule {}
